/** When api needs to receives a list of values in queryParams
* We need to transform our Array in something they accept
@payloadQueryParams { Array, Object } - payload params
@return { string } - url built
*/
export const buildUrlParams = (payloadQueryParams, allowEmptyQueryParams) => {
    var temp = new URLSearchParams()
    for (var key in payloadQueryParams) {
        if (payloadQueryParams[key] ||
            (allowEmptyQueryParams && !payloadQueryParams[key]) ||
            payloadQueryParams[key] === false ||
            payloadQueryParams[key] === 0) {
            if (Array.isArray(payloadQueryParams[key])) {
                payloadQueryParams[key].forEach(elem => {
                    temp.append(`${key}`, `${elem}`)
                })
            } else if (payloadQueryParams[key] instanceof Date) {
                temp.append(`${key}`, payloadQueryParams[key].toISOString())
            } else {
                temp.append(`${key}`, `${payloadQueryParams[key]}`)
            }
        }
    }
    return temp
}
